import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../../../my-app/src/environments/environment';
// import { environment } from '../../../../../libs/shared/libraries/my-app/src/environments/environment';.

const AGENT_API_URL = (environment as { agentApiUrl?: string }).agentApiUrl ?? '';

@Injectable({
  providedIn: 'root',
})
export class ChatApiService {
  protected _sessionId: string | null = null;

  constructor(
    protected http: HttpClient,
    protected keycloakService: KeycloakService,
  ) {}

  /**
   * Sends a message to the agent API and processes the response.
   * @param message The message from the user.
   * @param tableData Optional table data.
   * @param jsonData Optional JSON data.
   */
  async sendMessage(
  message: string,
  tableData?: any[],
  jsonData?: any,
  apiUrl?: string
): Promise<Observable<any>> {

  const isLoggedIn = await this.keycloakService.isLoggedIn();
  let userId = 'anonymous';

  if (isLoggedIn) {
    const keycloakInstance = this.keycloakService.getKeycloakInstance();
    userId = keycloakInstance.tokenParsed?.['sub'] || 'anonymous';
  }

  const requestPayload = this.getRequestPayload(
    userId,
    this._sessionId,
    message
  );

  const baseUrl = this.getBaseUrl(apiUrl);

  return this.http.post<any>(baseUrl, requestPayload);
}

  protected getRequestPayload(userId: string, sessionId: string | null, message: string): any {
    return {
      userId: userId,
      sessionId: sessionId || 'anonymous',
      message: message,
    };
  }

  async createSession() {
    const isLoggedIn = await this.keycloakService.isLoggedIn();
    let userId = 'anonymous';
    const appName = 'user_workflow_agent'; // Hardcoded appName

    if (isLoggedIn) {
      userId = this.keycloakService.getKeycloakInstance().tokenParsed?.['sub'] || 'anonymous';
    }

    const baseUrl = this.getBaseUrl();
    const sessionApiUrl = `${baseUrl}/apps/${appName}/users/${userId}/sessions`;

    return this.http.post<any>(sessionApiUrl, {}).pipe(
      tap((response) => {
        console.log('Session creation response:', response);
        if (response && response.id) {
          this._sessionId = response.id;
          // console.log('Session ID:', this._sessionId)
        }
      }),
    );
  }

  protected getBaseUrl(apiUrl?: string): string {
    let baseUrl = AGENT_API_URL;
    if (apiUrl) {
      if (apiUrl.startsWith('http')) {
        baseUrl = apiUrl;
      } else {
        const base = AGENT_API_URL.endsWith('/') ? AGENT_API_URL.slice(0, -1) : AGENT_API_URL;
        const path = apiUrl.startsWith('/') ? apiUrl : `/${apiUrl}`;
        baseUrl = `${base}${path}`;
      }
    }
    return baseUrl;
  }
}
